export const UPDATE_LOGIN_STATE='UPDATE_LOGIN_STATE'
export const CLIENT_LOGIN='CLIENT_LOGIN'
export const SET_LOGIN_MESSAGE='SET_LOGIN_MESSAGE'
export const SET_USERS_SESSION='SET_USERS_SESSION'
export const SET_USER_SESSION_END='SET_USER_SESSION_END';
export const RESET_LOGIN_STATE="RESET_LOGIN_STATE";

